import { syncReferralRewardWithRollback } from "@/cart/maticReferralReward";
import type { CartStateGetSet } from "@/cart/types";
import GRAPHQL_CLIENT from "@/graphql/client";
import type { Cart } from "@/graphql/storefront/generated";
import posthog from "posthog-js";
import {
  isLegacyReferralReward,
  isMatic,
  isReferralRewardBagPass,
} from "@/utils/ShopifyHelpers";
import { syncPerMaticAddOnsToMatics } from "@/cart/syncPerMaticAddOnsToMatics";

export const removeItem = ({ set, get }: CartStateGetSet) => {
  const syncReferralReward = syncReferralRewardWithRollback({ get, set });

  return async (lineId: string) => {
    const { cartId, cart: currentCart } = get();
    if (!cartId) {
      console.warn(
        "Attempted to remove item from cart, but cartId is undefined",
      );
      return;
    }

    const isLineIdMatic = currentCart?.lines?.edges?.some(
      ({ node }) => node.id === lineId && isMatic(node),
    );
    const dependentLineIds = isLineIdMatic
      ? (currentCart?.lines?.edges
          ?.filter(
            ({ node }) =>
              isLegacyReferralReward(node) || isReferralRewardBagPass(node),
          )
          .map(({ node }) => node.id) ?? [])
      : [];

    const lineIdsToRemove = [lineId, ...dependentLineIds];

    const variantId = currentCart?.lines?.edges?.find(
      ({ node }) => node.id === lineId,
    )?.node.merchandise.id;
    posthog.capture("remove_item", { lineId, variantId, cartId });

    const { cartLinesRemove } = await GRAPHQL_CLIENT.RemoveFromCart({
      cartId,
      lineIds: lineIdsToRemove,
    });
    let cart = cartLinesRemove?.cart as Cart;
    if (!cart) throw new Error("cartLinesRemove failed");

    if (isLineIdMatic) {
      try {
        cart = await syncPerMaticAddOnsToMatics(cart);
      } catch (error) {
        console.error("Failed to sync add-ons after Matic removal:", error);
      }
      try {
        await syncReferralReward(currentCart, cart);
      } catch (error) {
        console.error(
          "Failed to sync referral reward after Matic removal:",
          error,
        );
      }
      return;
    }

    set({
      cartId: cart.id,
      cart: cart,
    });
  };
};
